import { Map, Set } from "immutable";

export enum TutorialActionTypes {
  LOAD_PLAYBACK_SPEED = "LOAD_PLAYBACK_SPEED",
  SET_PLAYBACK_SPEED = "SET_PLAYBACK_SPEED",
  MARK_CHAPTER_COMPLETE = "MARK_CHAPTER_COMPLETE",
  SET_LAST_CHAPTER = "SET_LAST_CHAPTER",
  SET_MANUAL_PAUSE = "SET_MANUAL_PAUSE",
}

export type SetPlaybackSpeed =  {
    type: typeof TutorialActionTypes.SET_PLAYBACK_SPEED;
    payload: number;
  }

export type SetManualPause =  {
    type: typeof TutorialActionTypes.SET_MANUAL_PAUSE;
    payload: {manualPause: boolean};
  }

export interface CompletionData {
  lesson: number;
  chapter: number;
}

export interface LastChapterData {
  lesson: number;
  chapter: number;
}

// Maps a lesson number to a set of completed chapters within it
export type CompletionState = {
  completed: Map<number, Set<number>>;
  lastChapter: Map<number, number>;
};


export type MarkAsCompleted = {
  type: typeof TutorialActionTypes.MARK_CHAPTER_COMPLETE;
  payload: CompletionData;
};

export type SetLastChapter = {
  type: typeof TutorialActionTypes.SET_LAST_CHAPTER;
  payload: LastChapterData;
};


export interface ChapterReducer {
  chapterReducer: CompletionState;
}

export type TutorialAction =
  | MarkAsCompleted
  | SetLastChapter
  | SetPlaybackSpeed
  | SetManualPause;